import React from "react";
import { Chip, Typography } from "@mui/material";
import { MAX_CHIPS_IN_LIST } from "modules/topics/styles/constants";
import { BasicAudience } from "modules/audiences";
import ChipList from "modules/common/components/chipList";
import EmptyMandatoryAudienceChip from "./emptyMandatoryAudienceChip";

interface ComponentProps {
    show: boolean;
    editable: boolean;
    selected: BasicAudience[];
    defaultChip?: string;
    onSelectAudience?: (audience: BasicAudience) => void;
}

const TopicAudienceChips: React.FunctionComponent<ComponentProps> = (props) => {

    const getNotApplicable = () : JSX.Element =>
        <Typography color="grey" fontSize="14px">
            <i> Not applicable </i>
        </Typography>;

    const getChips = () :JSX.Element => {
        return !props.selected?.length ?
            <Chip
                label={!!props.defaultChip ? <EmptyMandatoryAudienceChip/> : <i>All users</i>}
                className={"chip-default"}
                disabled={true}
            /> :
            <ChipList closable={props.editable}
                onClose={props.onSelectAudience}
                truncateAtIndex={MAX_CHIPS_IN_LIST}
                items={props.selected}
            />;
    };

    return (
        <React.Fragment>
            {!props.show ? getNotApplicable() : getChips()}
        </React.Fragment>
    );
};

export default TopicAudienceChips;